import '../../Pages/Client/Cvtheque/CvTheque.scss';

import { Add } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, Dialog, FormControl, IconButton, Toolbar } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import useFormValidation from '../../hooks/useFormValidation';
import usePostRequest from '../../hooks/usePostRequest';
import useUtilities from '../../hooks/useUtilities';
import { buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { IconTextField, Transition } from '../shared/ReusableSmallComponents';

function DialogChatterInvitation({openChatter, handleOpenChatter}) {
    DialogChatterInvitation.propTypes = {
        openChatter: PropTypes.any,
        handleOpenChatter: PropTypes.func,
    };

    const { setShowErrors, setErrors } = useUtilities();
    const { postData } = usePostRequest();
    const { i18n } = useTranslation();
    const [emailTo, setEmailTo] = useState('');
    const [firstMessage, setFirstMessage] = useState('');

    const [isValid] = useFormValidation([
        { name: 'emailTo', value: emailTo },
        { name: 'firstMessage', value: firstMessage },
    ]);

    const startConversation = async () => {
        try {
            postData({
                url: '/conversation/send', payload: {
                    emailTo: emailTo,
                    message:firstMessage
                }
            });
            resetDataAndClose();
        } catch (error) {
            console.log(error.response?.status, error.response?.data.error);
        }
    };
    const scroll='paper';

    const resetDataAndClose = () => {
        setFirstMessage('');
        setEmailTo('');
        handleOpenChatter();
    };
    return (
        <Dialog
            fullScreen
            open={openChatter}
            TransitionComponent={Transition}
            onClose={resetDataAndClose}
            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={resetDataAndClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <form style={{display:'flex',background: '#F5F6FA',paddingTop: '150px',justifyContent:'center',width:'100%'}}>
                <div className='frame14Modified4ClasserCvTheque'>
                    <h4
                        className='titlesociete'
                        style={{width: '700px'}}
                    >{i18n.t('Commencer le chat avec un utilisateur')}</h4>
                    <FormControl style={{display:'flex',gap:'12px',alignSelf:'stretch'}}>
                        <div style={{display:'flex',flexDirection:'column',gap:'8px',width:'100%'}}>
                            <h6 className='nomPrenomProfile'>{i18n.t('Informations de l\'utilisateur.')}</h6>
                            <IconTextField
                                //id="outlined-name"
                                //label="Nom"
                                placeholder={i18n.t('Veuillez saisir l`adresse e-mail de l`utilisateur.')}
                                style={{width:'100%', borderRadius:'8px',background:'white'}}
                                sx={{
                                    '& > :not(style)': { borderRadius:'8px' },
                                }}
                                iconStart={<Add />}

                                name='emailTo'
                                value={emailTo}
                                onChange={(e) => setEmailTo(e.target.value)}
                                autoComplete='off'
                                //endIcon={<AddIcon />}
                            />
                            <IconTextField
                                //id="outlined-name"
                                //label="Nom"
                                placeholder={i18n.t('Veuillez saisir le premier message.')}
                                style={{width:'100%', borderRadius:'8px',background:'white'}}
                                sx={{
                                    '& > :not(style)': { borderRadius:'8px' },
                                }}
                                iconEnd={<Add />}
                                //InputProps={{
                                //    endAdornment: (
                                //        <div className='iconStyleStartAdornment iconStyleEndAdornment'>
                                //            <InputAdornment position="end">
                                //                <Add />
                                //            </InputAdornment>
                                //        </div>
                                //    ),
                                //}}
                                name='firstMessage'
                                value={firstMessage}
                                onChange={(e) => setFirstMessage(e.target.value)}
                                autoComplete='off'
                                multiline
                                rows={4}
                                maxRows={5}
                                //endIcon={<AddIcon />}
                            />
                        </div>
                        <div style={{display:'flex',alignSelf:'stretch',justifyContent:'flex-end'}}>
                            <Button
                                variant='text'
                                style={{ width: '118px' }}
                                onClick={resetDataAndClose}
                            >{i18n.t('Annuler')}</Button>
                            <Button
                                variant='contained'
                                style={{...buttonStylesGreen(false),...{width: '111px',}}}
                                type='submit'
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (isValid) {
                                        startConversation();
                                        resetDataAndClose();
                                        setShowErrors(false);
                                        setErrors({});
                                    }
                                    else setShowErrors(true);
                                }}
                            >
                                {i18n.t('Envoyer')}
                            </Button>
                        </div>
                    </FormControl>
                </div>
            </form>
        </Dialog>
    );
}

export default DialogChatterInvitation;
